import { Flex } from '@applyboard/crystal-ui';

import { PageHeader } from '~/components/PageHeader';
import { SelectedIntakesBar } from '../components';
import {
  CampusFilter,
  IntakeFilter,
  IntakesFilterSummary,
  IntakesPagination,
  IntakesTable,
  QueryFilter,
  Sort,
  StatusFilter,
} from '~/components/Intake';

export function MobileLayout() {
  return (
    <Flex p={10} gap={3} direction="column">
      <PageHeader title="Intake Management" />
      <Filter as={<QueryFilter />} width="100%" />
      <Filter as={<CampusFilter />} width="100%" />
      <Filter as={<IntakeFilter />} width="100%" />
      <Filter as={<StatusFilter />} width="100%" />
      <Filter as={<Sort />} width="100%" />
      <Flex pt={2}>
        <IntakesFilterSummary />
      </Flex>
      <SelectedIntakesBar />
      <IntakesTable />
      <IntakesPagination />
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
